import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import {IconButton, Grid, Typography, Button, TextField, Select, MenuItem} from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

import { ProductCard } from './components';
import { getUnvalidatedOffers } from '../../utils/requests';
import PropTypes from 'prop-types';
// import Account from "../Account";
import moment from 'moment';
import { SearchInput } from 'components';
import Cookies from 'universal-cookie';
import majors from '../NewOffer/components/Form/majors';
import uuid from 'uuid/v1';

const cookies = new Cookies();
const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  },
  pagination: {
    marginTop: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1)
  },
  spacer: {
    flexGrow: 1
  },
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  searchInput: {
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1)
  }
}));




let isLoading = true;

function useForceUpdate(){
  const [value, setValue] = useState(0); // integer state
  return () => setValue(value => ++value); // update the state to force render
}

const filterOptions = [
  {
    value: 'title',
    label: 'Title'
  },
  {
    value: 'position',
    label: 'Position'
  },
  {
    value: 'company_name',
    label: 'Company'
  },
  {
    value: 'targeted_major',
    label: 'Major'
  }
];

const sortOptions = [
  {
    value: 'recent',
    label: 'Most recent'
  },
  {
    value: 'oldest',
    label: 'Oldest'
  }
];

const majorOptions = majors;
majorOptions.push({
  id: uuid(),
  code: 'Majors',
  major_name: 'NONE'
});

const getAvailableOffers = async (forceUpdate, history) =>{

  if(isLoading){
    return getUnvalidatedOffers(history)
      .then((res) => {
        // console.log(res)
        if(res === 6){ //error code expired app tokken

        } else if (res){
          isLoading = false;
          data = res;
          // console.log(data)
          forceUpdate();
        } else{
          alert('An arror happened while fetching for data');
          history.push('/sign-in')
        }
      })
  }
};

let data ;

const ProductList = (props) => {
  const classes = useStyles();
  const { history } = props;

  // console.log(data);
  const [filterValue, setFilterValue] = useState((history.location.state)?history.location.state.filter:'title');
  const [sortValue, setSortValue] = useState('recent');
  const [searchValue, setSearchValue] = useState((history.location.state)?history.location.state.search:'');
  const [majorValue, setMajorValue] = useState('Majors');



  const forceUpdate = useForceUpdate();
  getAvailableOffers(forceUpdate, history);


  const handleSortChange = (event) => {
    event.persist();
    if(event.target.value.match(/^[a-zA-Z0-9\s._èéêàá?!\[\]();,-]*$/)) {
      if(sortValue === 'recent')
        data.sort((a, b) => moment(a.createdAt).valueOf() - moment(b.createdAt).valueOf());
      else if(sortValue === 'oldest')
        data.sort((a, b) => moment(b.createdAt).valueOf() - moment(a.createdAt).valueOf());
      setSortValue(event.target.value);
    }
  };
  const handleSearchChange = (event) => {
    event.persist();
    if(event.target.value.match(/^[a-zA-Z0-9\s._èéêàá?!\[\]();,-]*$/)) {
      setSearchValue(event.target.value);
    }
  };
  const handleFilterChange = (event) => {
    event.persist();
    if(event.target.value.match(/^[a-zA-Z0-9\s._èéêàá?!\[\]();,-]*$/)) {
      setFilterValue(event.target.value);
    }
  };
  const handleMajorChange = (event) => {
    event.persist();
    if(event.target.value.match(/^[a-zA-Z0-9\s._èéêàá?!\[\]();,-]*$/)) {
      if(event.target.value !== 'Majors'){
        setSearchValue(event.target.value);
        setMajorValue(event.target.value);
      }
    }
  }

  return (
    <div className={classes.root}>
      <div>
        <div className={classes.row}>
          <span className={classes.spacer} />
          {(cookies.get('isAlumni') === 'true')?
            <Button
              color="primary"
              href="/my-offers/new"
              variant="contained"
            >
              Add an internship
            </Button>
            :
            <div />
          }
        </div>
        <div className={classes.row}>
          <Select
            id="demo-simple-select"
            labelId="demo-simple-select-label"
            onChange={handleFilterChange}
            select
            SelectProps={{native: true}}
            // eslint-disable-next-line react/jsx-sort-props
            value={filterValue || ''}
            value={filterValue}
            variant="outlined"
          >
            {filterOptions.map(option => (
              <MenuItem
                key={option.value}
                value={option.value}
              >
                {option.label}
              </MenuItem>
            ))}
          </Select>
          {/* </TextField> */}
          {
            (filterValue !== 'targeted_major')
              ?
              <SearchInput
                className={classes.searchInput}
                onChange={handleSearchChange}
                placeholder="Search"
                value={searchValue}
              />
              :
              <Select
                label="Major"
                margin="dense"
                name="major"
                onChange={handleMajorChange}
                select
                style={{marginLeft: 10}}
                SelectProps={{native: true}}
                // eslint-disable-next-line react/jsx-sort-props
                value={majorValue || 'BBA'}
                value={majorValue}
                variant="outlined"
              >
                {majorOptions.map(option => (
                  <MenuItem
                    key={option.code}
                    value={option.code}
                  >
                    {option.code}
                  </MenuItem>
                ))}
              </Select>
          }
          <span className={classes.spacer} />
          <Select
            label="Sort"
            margin="dense"
            name="sort"
            onChange={handleSortChange}
            select
            SelectProps={{native: true}}
            // eslint-disable-next-line react/jsx-sort-props
            value={sortValue || ''}
            value={sortValue}
            variant="outlined"
          >
            {sortOptions.map(option => (
              <MenuItem
                key={option.value}
                value={option.value}
              >
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </div>
      </div>
      {!isLoading &&
      <div className={classes.content}>
        <Grid
          container
          spacing={3}
        >
          {data.filter(d => d[filterValue].includes(searchValue)).map(offer => (
            <Grid
              item
              lg={4}
              md={6}
              xs={12}
            >
              <ProductCard
                key={offer.hashed_id}
                product={offer}
              />
            </Grid>
          ))}
        </Grid>
      </div>
      }
      <div className={classes.pagination}>
        <Typography variant="caption">1-6 of 20</Typography>
        <IconButton>
          <ChevronLeftIcon />
        </IconButton>
        <IconButton>
          <ChevronRightIcon />
        </IconButton>
      </div>
    </div>
  );
};


ProductList.propTypes = {
  history: PropTypes.object
};

export default ProductList;
